import { DateTimeColumn } from "@/components/tableColumns/DateTimeColumn";
import { NumberColumn } from "@/components/tableColumns/NumberColumn";
import { Button } from "@/components/ui/button";
import { StructureEvents } from "@/endpoints/dryp/event";
import { ColumnDef } from "@tanstack/react-table";
import "@tanstack/react-table";

const columnConfig = {
	enableSorting: false,
	meta: {
		headerClassName: "bg-blue-300",
	},
};

export const Columns: ColumnDef<StructureEvents>[] = [
	{
		...columnConfig,
		id: "expander",
		header: () => "",
		enableHiding: false,
		cell: ({ row }) => (
			<Button
				variant="ghost"
				size="sm"
				onClick={e => {
					e.stopPropagation();
					row.toggleExpanded();
				}}
			>
				{row.getIsExpanded() ? "−" : "+"}
			</Button>
		),
		meta: {
			...columnConfig.meta,
			enableExport: false,
		},
	},
	{
		...columnConfig,
		accessorKey: "Events",
		id: "Events",
		header: "Events",
		cell: ({ row }) => {
			const events = row.original.events;
			const eventCount = Array.isArray(events) ? events.length : 0;
			return <span>{eventCount}</span>;
		},
		meta: {
			...columnConfig.meta,
			exportFormat: (_: unknown, row: StructureEvents) => {
				return Array.isArray(row.events) ? row.events.length : 0;
			},
		},
	},
	{
		...columnConfig,
		accessorKey: "structure.name",
		id: "structure.name",
		header: "Structure",
	},
	{
		...columnConfig,
		accessorKey: "structure.description",
		id: "description",
		header: "Description",
	},
	NumberColumn<StructureEvents>({
		...columnConfig,
		accessorKey: "rainAccumulation.value",
		id: "rainAccumulation.value",
		header: "Rain",
		align: "left",
		d3Format: ".2f",
		meta: {
			unit: "m",
			...columnConfig.meta,
		},
	}),
	NumberColumn<StructureEvents>({
		...columnConfig,
		accessorKey: "overflow.value",
		id: "overflow.value",
		header: "Volume",
		align: "left",
		d3Format: ".2f",
		meta: {
			unit: "m3",
			...columnConfig.meta,
		},
	}),
	DateTimeColumn({
		...columnConfig,
		accessorKey: "lastEventDate",
		id: "lastEventDate",
		header: "Last event",
		format: "dd LLL yyyy, HH:mm",
		align: "left",
		datetimeClassName: "text-sm",
	}),
];
